import TagManager from "react-gtm-module";
import { Cookies } from "react-cookie-consent";
import { COOKIE_NAME } from "config";

let gtmInitialized = false;

/** Initializes Google Tag Manager. No-op if already initialized or not in production. */
export const startGTM = () => {
  if (gtmInitialized) return;
  const GTM_ID = process.env.REACT_APP_GOOGLE_TAG_MANAGER_ID || "";

  if (process.env.NODE_ENV === "production" && !!GTM_ID) {
    TagManager.initialize({ gtmId: GTM_ID });
    gtmInitialized = true;
  }
};

/**
 * Persists cookie consent, starts GTM, and dispatches a custom event so all
 * consent-gated components update without requiring a page reload.
 */
export const acceptCookieConsent = () => {
  Cookies.set(COOKIE_NAME, "true", { expires: 365 });
  startGTM();
  window.dispatchEvent(new CustomEvent("cookieConsentAccepted"));
};
